var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.componentTarget,{tag:"component",attrs:{"algorithmInfo":_vm.algorithmInfo},model:{value:(_vm.api_data),callback:function ($$v) {_vm.api_data=$$v},expression:"api_data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }